import React, {Component} from 'react';
import Navbar from "../Common/Navbar";
import Actionbar from "../Common/Actionbar";
import {headers} from "../../configs";
import API from "../../services/API";
import EmptyPic from "../../assets/images/emptypic.png";
import {MapContainer, TileLayer, Marker} from 'react-leaflet'
import L from 'leaflet';
import "leaflet/dist/leaflet.css"
import icon from '../../assets/images/user-pos.png';
import Loading from "../Common/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as faSolidStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faRegularStar } from "@fortawesome/free-regular-svg-icons";
let DefaultIcon = L.icon({
    iconUrl: icon,
    iconSize: [8,8],
});
L.Marker.prototype.options.icon = DefaultIcon;
class Home extends Component {
    state = {
        user : null,
        car : null,
        lat: parseFloat(window.localStorage.getItem("d-lat")),
        lng: parseFloat(window.localStorage.getItem("d-lng")),
    }
    onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }
    render() {
        return (
            <React.Fragment >
                {!this.state.isLoaded ? <Loading/> :''}
                <Actionbar noBack={1} title='صفحه اصلی'/>
                <section className="container my-5 py-5 ">
                    <div className="row text-center">
                        <div className="col-12 ">
                            <img alt="Avatar"
                                 src={this.state.user ? (this.state.user.avatar ? this.state.user.avatar : EmptyPic) : EmptyPic}
                                 width={128} className='rounded-circle custom-border'/>
                        </div>
                        <div className="col-12 mt-3">
                            {this.state.user ?
                                <div className='fw-bold text-big15 text-dark'>
                                    {this.state.user.first_name}
                                    &nbsp;
                                    {this.state.user.last_name}
                                </div>
                                : ''
                            }

                        </div>
                        <div className="col-12 mt-5">
                            {this.state.car ?
                                <div className='text-secondary'>
                                    خودروی
                                    &nbsp;
                                    {this.state.car.type}
                                    &nbsp;
                                    {this.state.car.color}

                                    <span className="small d-block mt-3">
                                         به شماره پلاک:
                                        &nbsp;
                                        {this.state.car.plaque}
                                    </span>
                                </div>
                                : ''
                            }
                        </div>
                        {this.state.user?.rate > 0 && (
                            <div className='mt-4'>
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <FontAwesomeIcon
                                        key={star}
                                        icon={star <= this.state.user?.rate ? faSolidStar : faRegularStar}
                                        style={{ color: "#ffc107", fontSize: 14, marginLeft: 2 }}
                                    />
                                ))}
                                <span className="mx-2 super-small-2">({this.state.user?.rate})</span>
                            </div>
                        )}
                        <div className="col-12 text-center fw-bold  my-2 rtl">


                            {
                                this.state.user?.in_black_list > 0 &&
                                <div className='alert alert-danger super-small-2 p-0 text-center mt-2'
                                     style={{fontSize: '12px'}}>
                                    شما در حال حاضر در لیست سیاه قرار دارید!
                                </div>
                            }
                            {
                                this.state.user?.in_warning_list > 0 &&
                                <div className='alert alert-warning super-small-2 p-0 text-center mt-2'
                                     style={{fontSize: '12px'}}>
                                    شما در حال حاضر در لیست تذکر قرار دارید!
                                </div>
                            }
                        </div>
                        <div className="col-12 px-3 mt-5 pt-4">
                            {
                                this.state.lat ?
                                    <MapContainer
                                        center={[this.state.lat.toFixed(4), this.state.lng.toFixed(4)]}
                                        zoom={13}
                                        scrollWheelZoom={true}
                                        className="driver-map px-2 rounded-more"
                                    >
                                        <TileLayer
                                            attribution='&copy; <a href="https://barsepar.com">سامانه بارسپار</a> '
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        />
                                        <Marker
                                            position={[this.state.lat.toFixed(4), this.state.lng.toFixed(4)]}
                                        />
                                    </MapContainer>
                                    : ''
                            }

                        </div>
                    </div>
                </section>
                <Navbar/>
            </React.Fragment>
        );
    }

    componentDidMount() {

        if (headers.Authorization.length < 15) {
            window.location.replace('/')
        }
        const push_id = window.localStorage.getItem("npid");
        if (push_id) {
            const request = {
                push_id
            }
            API.setPushToken(request)
                .then((response) => {

                    const user = response.results.user;
                    this.setState({user});
                })
        }
        API.index()
            .then((response) => {
                const user = response.results.user;
                const car = response.results.cars;
                this.setState({user, car});
                this.setState({isLoaded: true})
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            })
    }
}

export default Home;